/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RequirementsInputs */

const en_requirements = /** @type {(inputs: RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirements`)
};

const de_requirements = /** @type {(inputs: RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anforderungen`)
};

/**
* | output |
* | --- |
* | "Requirements" |
*
* @param {RequirementsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const requirements = /** @type {((inputs?: RequirementsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RequirementsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_requirements(inputs)
	return en_requirements(inputs)
});